import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/dashboard-tokens.css';
import App from "./App";
import {AuthLoginProvider} from "./profile/auth-login";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthLoginProvider>
    <App />
  </AuthLoginProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
